const procedureTranslations = {
  en: {
    pageTitle: "Enrollment Process",
    intro:
      "At Akaal Kids, the enrollment process is designed to be simple, transparent, and parent-friendly, ensuring that every learner joins the most suitable batch with confidence and clarity.",
    steps: [
      {
        title: "Step 1: Initial Contact",
        desc: "Parents may begin the enrollment process in either of the following ways:",
        points: [
          'Visiting our website and clicking on "Enroll Now"',
          "Sending us a message on WhatsApp",
          "Our team responds personally to guide parents through the next steps.",
        ],
      },
      {
        title: "Step 2: Learner Assessment",
        desc: "Before placing a student into a batch:",
        points: [
          "The learner’s Punjabi reading ability and Gurbani familiarity are assessed",
          "This helps us understand the learner’s comfort level and learning needs",
          "Assessment is gentle and supportive, with no pressure on the child.",
        ],
      },
      {
        title: "Step 3: Batch Placement",
        desc: "Based on the assessment:",
        points: [
          "The learner is placed in a level-appropriate batch",
          "Placement is done according to understanding and readiness, not age",
          "Parents are informed clearly about the selected batch and expectations",
        ],
      },
      {
        title: "Step 4: Fee Confirmation",
        desc: "Once the batch is finalized:",
        points: [
          "Parents receive complete fee details",
          "Payment is completed through online modes",
          "Seat confirmation is done after successful payment",
          "To maintain quality learning, seats are limited in each batch.",
        ],
      },
      {
        title: "Step 5: Class Orientation",
        desc: "Before regular classes begin:",
        points: [
          "Parents receive class schedules according to their time zone",
          "Learning guidelines and expectations are shared",
          "The child is introduced gradually into the class environment",
        ],
      },
    ],
    supportHeading: "Ongoing Support",
    supportPoints: [
      "Parents receive regular feedback on progress",
      "Teachers remain available for guidance and support",
      "Batch placement can be reviewed if needed for the learner’s comfort",
    ],
    notesHeading: "Important Notes",
    notes: [
      "Admission is level-based, not age-based",
      "Classes are conducted in a safe, respectful, and supervised environment",
      "Consistent attendance and parental support are encouraged for best results",
    ],
    readyHeading: "Ready to Enroll?",
    readyText:
      "Give your child the gift of Gurbani — not just education, but a way of life.",
    enrollBtn: "Enroll Now",
    whatsappBtn: "Contact us on WhatsApp for assistance",
  },
  pa: {
    pageTitle: "ਦਾਖਲਾ ਪ੍ਰਕਿਰਿਆ",
    intro:
      "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਦਾਖਲੇ ਦੀ ਪ੍ਰਕਿਰਿਆ ਨੂੰ ਸਰਲ, ਸਪਸ਼ਟ ਅਤੇ ਮਾਤਾ-ਪਿਤਾ ਲਈ ਸੁਖਾਵਾਂ ਬਣਾਇਆ ਗਿਆ ਹੈ ਤਾਂ ਜੋ ਹਰ ਵਿਦਿਆਰਥੀ ਆਪਣੇ ਲਈ ਉਚਿਤ ਬੈਚ ਵਿੱਚ ਆਤਮ ਵਿਸ਼ਵਾਸ ਨਾਲ ਸ਼ਾਮਲ ਹੋ ਸਕੇ।",
    steps: [
      {
        title: "ਕਦਮ 1: ਸ਼ੁਰੂਆਤੀ ਸੰਪਰਕ",
        desc: "ਮਾਤਾ-ਪਿਤਾ ਦਾਖਲੇ ਦੀ ਸ਼ੁਰੂਆਤ ਹੇਠ ਲਿਖੇ ਤਰੀਕਿਆਂ ਨਾਲ ਕਰ ਸਕਦੇ ਹਨ:",
        points: [
          "ਸਾਡੀ ਵੈਬਸਾਈਟ ‘ਤੇ “Enroll Now” ‘ਤੇ ਕਲਿੱਕ ਕਰਕੇ",
          "ਜਾਂ ਵਟਸਐਪ ਰਾਹੀਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਕੇ।",
          "ਸਾਡੀ ਟੀਮ ਵਿਅਕਤੀਗਤ ਤੌਰ ‘ਤੇ ਮਦਦ ਕਰਦੀ ਹੈ।",
        ],
      },
      {
        title: "ਕਦਮ 2: ਵਿਦਿਆਰਥੀ ਦੀ ਜਾਂਚ",
        desc: "ਬੈਚ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ:",
        points: [
          "ਵਿਦਿਆਰਥੀ ਦੀ ਪੰਜਾਬੀ ਪੜ੍ਹਾਈ",
          "ਅਤੇ ਗੁਰਬਾਣੀ ਨਾਲ ਜਾਣ-ਪਛਾਣ ਦੀ ਹਲਕੀ ਅਤੇ ਸੁਖਾਵੀਂ ਜਾਂਚ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
          "ਇਸ ਵਿੱਚ ਕਿਸੇ ਵੀ ਤਰ੍ਹਾਂ ਦਾ ਦਬਾਅ ਨਹੀਂ ਹੁੰਦਾ।",
        ],
      },
      {
        title: "ਕਦਮ 3: ਬੈਚ ਚੋਣ",
        desc: "ਜਾਂਚ ਦੇ ਆਧਾਰ ‘ਤੇ:",
        points: [
          "ਵਿਦਿਆਰਥੀ ਨੂੰ ਉਸਦੇ ਸਿੱਖਣ ਦੇ ਪੱਧਰ ਅਨੁਸਾਰ ਬੈਚ ਵਿੱਚ ਰੱਖਿਆ ਜਾਂਦਾ ਹੈ",
          "ਦਾਖਲਾ ਉਮਰ ਨਹੀਂ, ਸਮਝ ਅਨੁਸਾਰ ਹੁੰਦਾ ਹੈ",
          "ਮਾਤਾ-ਪਿਤਾ ਨੂੰ ਪੂਰੀ ਜਾਣਕਾਰੀ ਦਿੱਤੀ ਜਾਂਦੀ ਹੈ",
        ],
      },
      {
        title: "ਕਦਮ 4: ਫੀਸ ਪੁਸ਼ਟੀ",
        desc: "ਬੈਚ ਫਾਈਨਲ ਹੋਣ ਤੋਂ ਬਾਅਦ:",
        points: [
          "ਫੀਸ ਦੀ ਪੂਰੀ ਜਾਣਕਾਰੀ ਸਾਂਝੀ ਕੀਤੀ ਜਾਂਦੀ ਹੈ",
          "ਆਨਲਾਈਨ ਭੁਗਤਾਨ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
          "ਭੁਗਤਾਨ ਤੋਂ ਬਾਅਦ ਸੀਟ ਪੁਸ਼ਟ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
          "ਉੱਚ ਗੁਣਵੱਤਾ ਬਣਾਈ ਰੱਖਣ ਲਈ ਸੀਟਾਂ ਸੀਮਿਤ ਹੁੰਦੀਆਂ ਹਨ।",
        ],
      },
      {
        title: "ਕਦਮ 5: ਕਲਾਸ ਸ਼ੁਰੂਆਤ",
        desc: "ਨਿਯਮਿਤ ਕਲਾਸਾਂ ਤੋਂ ਪਹਿਲਾਂ:",
        points: [
          "ਸਮੇਂ ਅਨੁਸਾਰ ਕਲਾਸ ਸ਼ਡਿਊਲ ਦਿੱਤਾ ਜਾਂਦਾ ਹੈ।",
          "ਸਿੱਖਣ ਦੇ ਨਿਯਮ ਸਮਝਾਏ ਜਾਂਦੇ ਹਨ।",
          "ਬੱਚੇ ਨੂੰ ਹੌਲੀ-ਹੌਲੀ ਕਲਾਸ ਮਾਹੌਲ ਨਾਲ ਜੋੜਿਆ ਜਾਂਦਾ ਹੈ।",
        ],
      },
    ],
    supportHeading: "ਲਗਾਤਾਰ ਸਹਿਯੋਗ",
    supportPoints: [
      "ਮਾਤਾ-ਪਿਤਾ ਨੂੰ ਨਿਰੰਤਰ ਬੱਚੇ ਦੀ ਤਰੱਕੀ ਬਾਰੇ ਜਾਣਕਾਰੀ ਦਿੱਤੀ ਜਾਵੇਗੀ ।",
      "ਅਧਿਆਪਕਾਂ ਵੱਲੋਂ ਮਾਰਗਦਰਸ਼ਨ ਦੱਸਿਆ ਜਾਵੇਗਾ ।",
      "ਯੋਗਤਾ ਅਨੁਸਾਰ ਬੈਚ ਚੋਣ ਦੀ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ।",
    ],
    notesHeading: "ਮਹੱਤਵਪੂਰਨ ਗੱਲਾਂ",
    notes: [
      "ਦਾਖਲਾ ਲੈਵਲ ਅਧਾਰਿਤ ਹੈ।",
      "ਸਾਰੀਆਂ ਕਲਾਸਾਂ ਸੁਰੱਖਿਅਤ ਅਤੇ ਸਤਿਕਾਰਪੂਰਕ ਮਾਹੌਲ ਵਿੱਚ ਦਿੱਤੀਆਂ ਜਾਣਗੀਆਂ ।",
      "ਨਿਯਮਿਤ ਹਾਜ਼ਰੀ ਅਤੇ ਮਾਤਾ-ਪਿਤਾ ਦਾ ਸਾਥ ਜ਼ਰੂਰੀ ਹੈ ।",
    ],
    readyHeading: "ਦਾਖਲੇ ਲਈ ਤਿਆਰ ਹੋ?",
    readyText:
      "ਆਪਣੇ ਬੱਚੇ ਨੂੰ ਗੁਰਬਾਣੀ ਦਾ ਉਪਹਾਰ ਦਿਓ — ਸਿਰਫ਼ ਸਿੱਖਿਆ ਨਹੀਂ, ਜੀਵਨ ਦਾ ਮਾਰਗ ਦਵੋ ।",
    enrollBtn: "Enroll Now",
    whatsappBtn: "ਵਟਸਐਪ ਰਾਹੀਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
  },
};

export default procedureTranslations;
